import React, { Component } from 'react';
import { Button, Modal } from 'semantic-ui-react'

class LogoutMessage extends Component {
  render() {
    return (
      <Modal className="logout-message" size={ 'mini' } dimmer={ 'inverted' } open={ this.props.show } onClose={ () => this.props.onClose() }>
        <Modal.Header>Logout</Modal.Header>
        <Modal.Content>
          <i className="exclamation circle icon"></i>
          In order to logout please shutdown your browser.
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="Ok"
            onClick={ () => this.props.onClose() }
          />
        </Modal.Actions>
      </Modal>
    )
  }
}
export default LogoutMessage;



// WEBPACK FOOTER //
// ./src/views/components/modals/logout_message.js